import Person from "./Person";

export default function PersonList({ persons }) {
  return persons.map((person) => <Person key={person.id} person={person} />);
}
